import Layout1 from '/public/siteImages/HomePageLayout/theme1/Layout1.png';
import Layout2 from '/public/siteImages/HomePageLayout/theme2/Layout2.png';
import Layout3 from '/public/siteImages/HomePageLayout/theme3/Layout3.png';
import Layout4 from '/public/siteImages/HomePageLayout/theme4/Layout4.png';

export {
    Layout1,
    Layout2,
    Layout3,
    Layout4,
}